/* eslint-disable no-unsafe-optional-chaining */
import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Icon,
  Radio,
  RadioGroup,
  Stack,
  Grid,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import colors from "assets/theme/base/colors";
// import AddComment from "./AddComment";
// import Comments from "./Comments";
import CurrencyInput from "./CurrencyInput";
import CustomizedSlider from "./CustomizedSlider";
import ReportActionWrapper from "./ReportActionWrapper";
import ScrollToFieldError from "./ScrollToFieldError";

const getFormElement = ({ question, index, value, setter, error, touched }) => {
  switch (question.type) {
    case "text": {
      return (
        <Stack key={question.id} id={`${index + 1}-${question.id}`}>
          <FormLabel sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}>
            {`${index + 1}. ${question.question}`}
          </FormLabel>
          <MDInput
            value={value || ""}
            multiline
            fullWidth
            variant="standard"
            onChange={(event) => {
              setter(`${index + 1}-${question.id}`, event.target.value);
            }}
            helperText={touched && error}
            error={touched && Boolean(error)}
            InputProps={{
              endAdornment: value && (
                <Icon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => setter(`${index + 1}-${question.id}`, "")}
                >
                  close
                </Icon>
              ),
            }}
          />
        </Stack>
      );
    }
    case "number": {
      return (
        <Stack key={question?.id} id={`${index + 1}-${question.id}`}>
          <FormLabel sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}>
            {`${index + 1}. ${question.question}`}
          </FormLabel>
          <MDInput
            value={value || ""}
            type="number"
            fullWidth
            variant="standard"
            onChange={(event) => {
              setter(`${index + 1}-${question.id}`, event.target.value);
            }}
            helperText={touched && error}
            error={touched && Boolean(error)}
            InputProps={{
              endAdornment: value && (
                <Icon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => setter(`${index + 1}-${question.id}`, null)}
                >
                  close
                </Icon>
              ),
            }}
          />
        </Stack>
      );
    }
    case "currency": {
      return (
        <Stack key={question?.id} id={`${index + 1}-${question.id}`}>
          <FormLabel sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}>
            {`${index + 1}. ${question.question}`}
          </FormLabel>
          <MDInput
            fullWidth
            value={value || ""}
            variant="standard"
            onChange={(event) => {
              setter(`${index + 1}-${question.id}`, event.target.value || "");
            }}
            helperText={touched && error}
            error={touched && Boolean(error)}
            InputProps={{
              inputComponent: CurrencyInput,
              endAdornment: value && (
                <Icon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => setter(`${index + 1}-${question.id}`, "")}
                >
                  close
                </Icon>
              ),
            }}
          />
        </Stack>
      );
    }
    case "pipeline health": {
      return (
        <Stack key={question?.id} spacing={2}>
          <FormLabel
            sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}
            id={`${index + 1}-${question.id}.0-${question.id}`}
            className={`${index + 1}-${question.id}.1-${question.childQuestionId}`}
          >
            {`${index + 1}. Pipeline Health`}
          </FormLabel>
          <MDInput
            fullWidth
            value={value?.[`0-${question.id}`] || ""}
            variant="standard"
            label={question.question}
            onChange={(event) => {
              setter(`${index + 1}-${question.id}.0-${question.id}`, event.target.value || "");
            }}
            helperText={touched?.[`0-${question.id}`] && error?.[`0-${question.id}`]}
            error={touched?.[`0-${question.id}`] && Boolean(error?.[`0-${question.id}`])}
            InputProps={{
              inputComponent: CurrencyInput,
              endAdornment: value && (
                <Icon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => setter(`${index + 1}-${question.id}.0-${question.id}`, "")}
                >
                  close
                </Icon>
              ),
            }}
          />
          <MDInput
            fullWidth
            value={value?.[`1-${question.childQuestionId}`] || ""}
            variant="standard"
            label={question.childQuestion}
            onChange={(event) => {
              setter(
                `${index + 1}-${question.id}.1-${question.childQuestionId}`,
                event.target.value || ""
              );
            }}
            helperText={
              touched?.[`1-${question.childQuestionId}`] && error?.[`1-${question.childQuestionId}`]
            }
            error={
              touched?.[`1-${question.childQuestionId}`] &&
              Boolean(error?.[`1-${question.childQuestionId}`])
            }
            InputProps={{
              inputComponent: CurrencyInput,
              endAdornment: value && (
                <Icon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setter(`${index + 1}-${question.id}.1-${question.childQuestionId}`, "")
                  }
                >
                  close
                </Icon>
              ),
            }}
          />
          <Stack direction="row">
            <MDTypography sx={{ fontSize: "16px" }}>Coverage:</MDTypography>
            <MDTypography sx={{ fontSize: "16px", width: "100%" }}>
              {value?.[`0-${question.id}`] && value?.[`1-${question.childQuestionId}`]
                ? `${(
                    value?.[`0-${question.id}`] / value?.[`1-${question.childQuestionId}`]
                  ).toFixed(2)} X`
                : ""}
            </MDTypography>
          </Stack>
        </Stack>
      );
    }
    case "true/false": {
      return (
        <Stack key={question?.id} id={`${index + 1}-${question.id}`}>
          <FormLabel sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}>
            {`${index + 1}. ${question.question}`}
          </FormLabel>

          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            onChange={(_, newValue) => {
              setter(`${index + 1}-${question.id}`, newValue === "true");
            }}
            value={typeof value !== "undefined" && typeof value !== "string" ? value : ""}
          >
            <FormControlLabel
              // name={`${index + 1}-${question.id}`}
              value
              sx={{ fontWeight: 400 }}
              control={<Radio />}
              label="True"
            />
            <FormControlLabel
              // name={`${index + 1}-${question.id}`}
              value={false}
              sx={{ fontWeight: 400 }}
              control={<Radio />}
              label="False"
            />
          </RadioGroup>
          {touched && Boolean(error) && <FormHelperText>{error}</FormHelperText>}
        </Stack>
      );
    }
    case "assessment": {
      return (
        <Stack key={question?.id} id={`${index + 1}-${question.id}`}>
          <FormLabel sx={{ fontSize: "16px", width: "100%", color: "#344767", fontWeight: 600 }}>
            {`${index + 1}. ${question.question}`}
          </FormLabel>

          <CustomizedSlider
            value={value || 0}
            onChange={(_, newValue) => {
              setter(`${index + 1}-${question.id}`, newValue);
            }}
          />
        </Stack>
      );
    }

    default: {
      return null;
    }
  }
};

function DynamicForm({
  questions,
  report,
  handleReportSubmit,
  // updateReportComment,
  // updateQuestionComment,
  showPreviousAnswers,
  setShowPreviousAnswers,
}) {
  const [formData, setFormData] = useState({});
  const [validationSchema, setValidationSchema] = useState({});

  // const handleAddComment = (data, questionId) => {
  //   updateQuestionComment(data, questionId);
  // };

  // const handleReportCommentAdd = (data) => {
  //   updateReportComment(data);
  // };

  const initForm = () => {
    const formObject = {};
    const validatonSchemaObject = {};

    questions.forEach((question, index) => {
      if (
        question.type !== "pipeline health" &&
        question.type !== "assessment" &&
        question.type !== "true/false"
      ) {
        formObject[`${index + 1}-${question.id}`] = question?.answer || "";
      } else if (question.type === "true/false") {
        formObject[`${index + 1}-${question.id}`] =
          typeof question?.answer !== "undefined" ? question?.answer : "";
      } else if (question.type === "assessment") {
        formObject[`${index + 1}-${question.id}`] = parseInt(question.answer, 10) || 0;
        // formObject[question.id] = question.answer || 0;
      } else {
        formObject[`${index + 1}-${question.id}`] = {
          [`0-${question.id}`]: question?.answer || "",
          [`1-${question.childQuestionId}`]: question?.childQuestionAnswer || "",
        };
      }

      if (question.type === "text") {
        validatonSchemaObject[`${index + 1}-${question.id}`] =
          Yup.string().required("Answer is required");
      } else if (question.type === "assessment") {
        validatonSchemaObject[`${index + 1}-${question.id}`] =
          Yup.number().required("Answer is required");
      } else if (question.type === "number") {
        validatonSchemaObject[`${index + 1}-${question.id}`] = Yup.number()
          .required("Answer is required")
          .min(0, "Minimum value is 1")
          .max(2147483647, "Maximum value is 2147483647");
      } else if (question.type === "currency") {
        validatonSchemaObject[`${index + 1}-${question.id}`] = Yup.number()
          .required("Answer is required")
          .min(0, "Minimum value is 1")
          .max(2147483647, "Maximum value is 2147483647");
      } else if (question.type === "true/false") {
        validatonSchemaObject[`${index + 1}-${question.id}`] = Yup.boolean()
          .required("Answer is required")
          .typeError("Answer is required");
      } else if (question.type === "pipeline health") {
        validatonSchemaObject[`${index + 1}-${question.id}`] = Yup.object().shape({
          [`0-${question.id}`]: Yup.number()
            .required("Answer is required")
            .min(0, "Minimum value is 1")
            .max(2147483647, "Maximum value is 2147483647"),
          [`1-${question.childQuestionId}`]: Yup.number()
            .required("Answer is required")
            .min(0, "Minimum value is 1")
            .max(2147483647, "Maximum value is 2147483647"),
        });
      }
    });

    setFormData(formObject);
    setValidationSchema(Yup.object().shape({ ...validatonSchemaObject }));
  };

  useEffect(() => {
    initForm();
  }, [questions]);

  return (
    <ReportActionWrapper
      reportData={report}
      showPreviousAnswersField
      showPreviousAnswers={showPreviousAnswers}
      setShowPreviousAnswers={setShowPreviousAnswers}
    >
      <MDBox sx={{ "& .MuiFormHelperText-root": { color: "#d32f2f" } }}>
        <Formik
          enableReinitialize
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleReportSubmit}
        >
          {({ values, touched, errors, setFieldValue, dirty }) => (
            <Form>
              <ScrollToFieldError />
              <Stack spacing={4} mt={2} p={2}>
                {questions.map((question, index) => (
                  <>
                    {getFormElement({
                      question,
                      index,
                      value: values[`${index + 1}-${question.id}`],
                      setter: setFieldValue,
                      error: errors[`${index + 1}-${question.id}`],
                      touched: touched[`${index + 1}-${question.id}`],
                    })}
                  </>
                ))}
              </Stack>
              <Grid container>
                {dirty && (
                  <Grid
                    item
                    xs={12}
                    sm={5}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mr: 2,
                      color: colors.warning.main,
                    }}
                  >
                    <Icon sx={{ mr: 1 }}>warning_amber</Icon>
                    <MDTypography
                      variant="button"
                      sx={{
                        color: colors.warning.main,
                      }}
                    >
                      Save draft or submit the report before leaving the page.
                    </MDTypography>
                  </Grid>
                )}
                <Grid item display="flex" xs={12} sm={6} justifyContent="flex-end">
                  {report.statusId !== "Ready For Review" && (
                    <MDButton
                      color="newColor"
                      variant="gradient"
                      size="small"
                      sx={{ mr: 2 }}
                      type="button"
                      onClick={() => handleReportSubmit(values, true)}
                      disabled={!dirty}
                    >
                      Save Draft
                    </MDButton>
                  )}
                  <MDButton
                    type="submit"
                    color="newColor"
                    variant="gradient"
                    size="small"
                    sx={{ mr: 2 }}
                  >
                    {report.statusId === "Ready For Review" ? "Resubmit" : "Submit"}
                  </MDButton>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </MDBox>
    </ReportActionWrapper>
  );
}

export default DynamicForm;
